import { z } from 'zod'

import { DescriptionSchema } from 'shared/api/common/schemas/templates/description'
import { ProtectedDataSchema } from 'shared/api/common/schemas/templates/protectedData'
import { BodyCreateRequestSchema } from 'shared/api/common/schemas/templates/requestBody'
import { TemplateSchema } from 'shared/api/common/schemas/templates/template'

export const templateApiSchemas = {
  fetch: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ templates: z.array(TemplateSchema) }),
  },
  delete: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ template_id: z.number() }),
    response: z.undefined(),
  },
  create: {
    path: z.undefined(),
    query: z.undefined(),
    request: BodyCreateRequestSchema,
    response: z.object({ data: TemplateSchema }),
  },
  fetchTemplate: {
    path: z.undefined(),
    query: z.object({ template_id: z.string() }),
    request: z.undefined(),
    response: z.object({ data: TemplateSchema }),
  },
  setTitle: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ template_id: z.number(), title: z.string() }),
    response: z.object({ data: TemplateSchema }),
  },
  setShare: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ template_id: z.number(), share: z.boolean() }),
    response: z.object({ data: TemplateSchema }),
  },
  setDescription: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ template_id: z.number(), description: DescriptionSchema }),
    response: z.object({ data: TemplateSchema }),
  },
  update: {
    path: z.undefined(),
    query: z.undefined(),
    request: BodyCreateRequestSchema,
    response: z.object({ data: TemplateSchema }),
  },
  updateAvatar: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      template_id: z.number(),
      avatar_file_id: z.number(),
      avatarURL: z.string().optional(),
    }),
    response: z.undefined(),
  },
  generateLink: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ template_id: z.number() }),
    response: z.object({
      data: z.object({
        share_hash: z.string(),
        share_link: z.string(),
        template_id: z.number(),
        template_installation_id: z.number().nullable(),
        ts_created: z.string(),
        ts_valid_till: z.string(),
      }),
    }),
  },
  setShareType: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ template_id: z.number(), share_type: z.number() }),
    response: z.object({ data: TemplateSchema }),
  },
  setIsProtected: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      is_protected: z.boolean(),
      page_id: z.string(),
      template_installation_id: z.number(),
    }),
    response: z.object({ data: ProtectedDataSchema }),
  },
  uploadImage: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.unknown(),
    response: z.object({ file_id: z.number(), url: z.string() }),
  },
}
